import React, { useState } from 'react';
import AnimatedLogoText from '../../../shared/components/AnimatedLogoText';
import { motion } from 'framer-motion';
import { slideUpFromBottomDelayed } from '../../../shared/helpers/animation';
import PageTransitionWrapper from '../../../shared/components/PageTransitionWrapper';
import { useAuth0 } from '@auth0/auth0-react';
import Button from '../../../shared/components/Button';
import { Buffer } from 'buffer';

const GetStarted: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const handleLogin = () => {
    loginWithRedirect();
  };

  // Obfuscated and delayed email link to prevent crawler scraping.
  // Inspired from https://github.com/darthdeus/react-obfuscated-mailto
  // But wait, this is too good and messes up browser handling of mailto:
  // links, e.g. if you set up the browser to use gmail as a protocol handler.
  const EmailText = () => {
    /*const email = Buffer.from("aW5mb0BzY2FmZm9sZC5oZWFsdGg=", "base64");
    return showEmail ?
              (<motion.a 
                href={"mailto:"+email} 
                className="text-white font-bold underline"
                variants={slideUpFromBottomDelayed}
                initial="hidden"
                animate="visible">
                {email.toString('ascii')}
              </motion.a>) : (<div/>);
    */
    return (<motion.a 
              href="mailto:info@scaffold.health?subject=Caloosha%20Account%20Request&body=Name:%0D%0AOrganization:"
              className="text-white font-bold underline"
              variants={slideUpFromBottomDelayed}
              initial="hidden"
              animate="visible"
            >
              Request an account
            </motion.a>);   
  }

  return (
    <PageTransitionWrapper>
      <main className="flex h-screen w-full items-center justify-center bg-gradient-to-bl from-cyan-400 to-cyan-900">
        <motion.div className="flex w-3/4 flex-col items-center p-6 md:w-2/4 lg:w-[500px]">
          <motion.div
            animate={{ scale: 1.05 }}
            transition={{
              repeat: Infinity,
              duration: 2,
              delay: 3,
              repeatType: 'reverse',
            }}
            className="mb-20 w-full"
          >
            <AnimatedLogoText color="white" />
          </motion.div>
          <div className="flex flex-col gap-5 items-center w-full"  key="doOnce">
            <Button
              label="Log in to your account"
              className="p-button-info w-full lg:w-3/5"
              onClick={() => {
                handleLogin();
              }}
              variants={slideUpFromBottomDelayed}
              initial="hidden"
              animate="visible"
            />
            <div className="flex flex-col items-center h-16">
              <EmailText/>
            </div>
          </div>
          
        </motion.div>
      </main>
    </PageTransitionWrapper>
  );
};

export default GetStarted;
